import { useProgramContentOverride } from '../contexts/DrugProgramProvider';
import type { FillPathway } from '../contexts/fill';
import type {
    AuthorizedMedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../graphql/generated/graphql';
import type { DrugKeyType } from '../util/config/constants';

import { useDrugKey } from './use-drug-key';

export const usePathwayAlerts = (
    medication:
        | AuthorizedMedicationInfoFragment
        | UnknownMedicationInfoFragment,
    pathway: FillPathway | null
) => {
    const drugKey = useDrugKey(medication);

    return usePathwayAlertsByDrugKey(drugKey, pathway);
};

export const usePathwayAlertsByDrugKey = (
    drugKey: DrugKeyType | null,
    pathway: FillPathway | null
) => {
    const content = useProgramContentOverride();
    const alerts = drugKey ? content.pathwayAlerts?.[drugKey] : null;

    if (!pathway || !alerts) return null;

    return alerts.find((alert) => alert.pathways.includes(pathway)) ?? null;
};
